const FallBack = () => {
  return <div style={{ marginTop: "20px", marginLeft: "20px", fontSize: "20px", textAlign: "center", fontWeight: 200 }}> An error occurred! </div>;
};

export default FallBack;
